module.exports = __webpack_public_path__ + "img/stopwatch2.2ed39b27.svg";